<li [ngClass]="{'selected': isSelected(item), 'main-tab': true}">
  <a
    (click)="item.child?.length > 0 ? expandOn(item) : itemSelected(item)"
  >
    <span class="nav-text"> {{item.label}} </span>
    <i class="material-icons" *ngIf="item.child?.length > 0">{{expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
  </a>
</li>

<div *ngIf="expanded">
  <app-menu
    *ngFor="let child of item.child"
    [item]="child"
    [selectedItem]="selectedItem"
    [onSelect]="onSelect.bind(this)"
  ></app-menu>
</div>
